<style lang="less" scoped>
.login {
  min-height: 100vh;
  display: flex;
  flex-direction: column;
  background-color: #F6F7F9;
  overflow-x: hidden;
}

.header {
  height: 72px;
  text-align: center;
  display: flex; /* 启用 Flexbox */
  align-items: center; /* 垂直居中 */
  justify-content: center; /* 水平居中 */
  background-color: #ffffff;
  z-index: 10;
}

.header-title {
  font-size: 20px;
  font-weight: 500;
  color: #000000;
  letter-spacing: 2px;

}

.main-content {
  flex: 1;
  display: flex;
  align-items: center;
  justify-content: center;
  padding: 60px 0px;
  gap: 0px;
  max-width: 1200px;
  margin: 0 auto;
  width: 100%;
}

.promo-panel {
  flex: 1;
  position: relative;
  display: flex;
  align-items: stretch;
  justify-content: center;
  height: 600px;
}

.promo-card {
  width: 100%;
  padding: 80px 110px;
  border-radius: 16px 0 0 16px;
  background-image: url('../assets/imgs/login/login-left.png');
  background-size: cover;
  background-position: center;
  background-repeat: no-repeat;
  position: relative;
  overflow: hidden;
  box-shadow: 0 10px 40px rgba(0, 0, 0, 0.1);
  height: 100%;
  display: flex;
  //align-items: center;
}

.promo-content {
  position: relative;
  z-index: 2;
}

.logo-circle {
  display: flex;
  align-items: center;
  gap: 8px;
  margin-bottom: 30px;
}

.logo-circle-item {
  width: 50px;
  height: 50px;
  border-radius: 50%;
  background-color: #9F1F18;
  display: flex;
  align-items: center;
  justify-content: center;
  box-shadow: 0 4px 12px rgba(211, 47, 47, 0.3);
}

.logo-text {
  color: #F5E4B7;
  text-align: center;
  font-family: "Songti SC";
  font-size: 26.4px;
  font-style: normal;
  font-weight: 400;
  line-height: 33.6px; /* 127.273% */
}

.promo-title {
  color: var(--red-100, #660E0B);
  text-shadow: 1px 1px 0 #F5E4B7;
  font-family: "Songti SC";
  font-size: 32px;
  font-style: normal;
  font-weight: 900;
  line-height: 42px; /* 131.25% */
}

.promo-description {
  color: var(--red-100, #660E0B);
  text-align: justify;
  font-family: "Songti SC";
  font-size: 14px;
  font-style: normal;
  font-weight: 400;
  line-height: normal;
  max-width: 435px;
}

.login-panel {
  flex: 0 0 420px;
  display: flex;
  align-items: stretch;
  justify-content: center;
  height: 600px;
}

.login-card {
  width: 100%;
  padding: 48px 40px;
  background: #ffffff;
  border-radius: 0 16px 16px 0;
  box-shadow: 0 10px 40px rgba(0, 0, 0, 0.1);
  height: 100%;
  display: flex;
  flex-direction: column;
  justify-content: center;
}

.login-title {
  color: var(--Grey-100, #1F1F20);
  text-align: center;

  /* Typography/UI 28 Bold */
  font-family: "PingFang SC";
  font-size: 28px;
  font-style: normal;
  font-weight: 600;
  line-height: 40px; /* 142.857% */
}

.login-form {
  .ant-form-item {
    margin-bottom: 24px;
  }

  /deep/ .ant-input-lg {
    height: 48px;
    line-height: 48px;
  }

  /deep/ .ant-input {
    height: 48px;
    line-height: 48px;
  }
}

.login-input {
  height: 48px !important;
  border-radius: 12px;
  font-size: 16px;

  /deep/ .ant-input {
    height: 48px;
    line-height: 48px;
  }
}

.login-links {
  display: flex;
  justify-content: space-between;
  margin-bottom: 24px;
  font-size: 14px;
}

.register-link {
  color: var(--Grey-100, #1F1F20);
  font-family: "PingFang SC";
  font-size: 16px;
  font-style: normal;
  font-weight: 400;
  line-height: 24px; /* 150% */

  .link-text {
    color: var(--red-60, #DC1212);

    /* Typography/UI 16 Bold */
    font-family: "PingFang SC";
    font-size: 16px;
    font-style: normal;
    font-weight: 600;
    line-height: 24px;
    cursor: pointer;

    &:hover {
      text-decoration: underline;
    }
  }
}

.forgot-password {
  color: var(--Grey-100, #1F1F20);
  font-family: "PingFang SC";
  font-size: 16px;
  font-style: normal;
  font-weight: 400;
  line-height: 24px; /* 150% */
  cursor: pointer;

  &:hover {
    color: #d32f2f;
    text-decoration: underline;
  }
}

.login-button {
  width: 100%;
  height: 48px;
  border-radius: 99px;
  font-size: 18px;
  font-weight: 500;
  margin-bottom: 20px;
}

/* 显式声明登录按钮各状态，避免打包后样式优先级变化 */
/deep/ .login-button.ant-btn-primary:not([disabled]) {
  background-color: #595959 !important;
  border-color: #595959 !important;
  color: #fff !important;
}

/deep/ .login-button.ant-btn-primary:not([disabled]):hover,
/deep/ .login-button.ant-btn-primary:not([disabled]):focus {
  background-color: #404040 !important;
  border-color: #404040 !important;
  color: #fff !important;
}

/deep/ .login-button.ant-btn-primary:not([disabled]):active {
  background-color: #333333 !important;
  border-color: #333333 !important;
  color: #fff !important;
}

/deep/ .login-button.ant-btn-primary[disabled] {
  background-color: #f5f5f5 !important;
  border-color: #d9d9d9 !important;
  color: rgba(0, 0, 0, 0.25) !important;
}

.agreement-checkbox {
  text-align: center;
  font-size: 14px;
  color: var(--Grey-100, #1F1F20);

  /deep/ .ant-checkbox-wrapper {
    color: #666666;
  }

  .link-text {
    color: var(--Grey-100, #1F1F20);

    /* Typography/UI 14 Bold */
    font-family: "PingFang SC";
    font-size: 14px;
    font-style: normal;
    font-weight: 600;
    line-height: 24px;

    &:hover {
      text-decoration: underline;
    }
  }
}

.teacher-note {
  display: flex;
  align-items: center;
  justify-content: center;
  gap: 8px;
  margin-bottom: 24px;
  text-align: center;

  .check-icon {
    color: #B7BABE;
    font-size: 16px;
  }

  .teacher-text {
    color: #000;
    font-family: "PingFang SC";
    font-size: 16px;
    font-style: normal;
    font-weight: 400;
    line-height: 24px;
  }

  .note-text {
    color: #85878A;
    font-family: "PingFang SC";
    font-size: 12px;
    font-style: normal;
    font-weight: 400;
    line-height: 16px; /* 133.333% */
  }
}

.verification-code {
  display: flex;
  gap: 12px;

  .code-input {
    flex: 1;
  }

  .code-button {
    flex: 0 0 120px;
    height: 48px;
  }
}

.login-link {
  text-align: center;
  margin-top: 20px;
  font-size: 14px;
  color: #666666;

  .link-text {
    color: var(--red-60, #DC1212);

    /* Typography/UI 16 Bold */
    font-family: "PingFang SC";
    font-size: 16px;
    font-style: normal;
    font-weight: 600;
    line-height: 24px;
    cursor: pointer;

    &:hover {
      text-decoration: underline;
    }
  }
}

.footer {
  background-color: #ffffff;
  padding: 40px 60px 30px 60px;
  border-top: 1px solid #f0f0f0;
}

.footer-content {
  max-width: 1200px;
  margin: 0 auto;
  display: flex;
  justify-content: space-between;
  padding: 0px 60px 0px 60px;
  align-items: flex-start;
  flex-wrap: wrap;
  gap: 40px;
}

.footer-left {
  display: flex;
  flex-direction: column;
  gap: 12px;
  flex: 1;
  min-width: 300px;
}

.footer-logo {
  display: flex;
  align-items: center;
  gap: 12px;
  margin-bottom: 8px;
}

.footer-logo-icon {
  width: 60px;
  height: 90px;
  display: flex;
  margin-right: 40px;
  align-items: center;
  justify-content: center;

  img,
  svg {
    width: 100%;
    height: 100%;
    object-fit: contain;
  }
}

.footer-title {
  color: var(--Grey-100, #1F1F20);

  /* Typography/UI 20 Bold */
  font-family: "PingFang SC";
  font-size: 20px;
  font-style: normal;
  font-weight: 600;
  line-height: 28px; /* 140% */
}

.footer-support {
  margin-top: 24px;
  color: var(--Grey-70, #444);

  /* Typography/UI 16 */
  font-family: "PingFang SC";
  font-size: 16px;
  font-style: normal;
  font-weight: 400;
  line-height: 24px; /* 150% */
}

.footer-qrcodes {
  display: flex;
  gap: 30px;
  flex-wrap: wrap;
}

.qrcode-item {
  text-align: center;

  .qrcode-label {
    font-size: 14px;
    color: #666666;
    margin-top: 8px;
  }

  .qrcode-box {
    width: 120px;
    height: 120px;
    border-radius: 8px;
    display: flex;
    align-items: center;
    justify-content: center;
    overflow: visible; /* 防止放大时被裁剪 */
    transition: transform 0.3s ease; /* 平滑过渡 */

    :hover {
      transform: scale(1.1); /* 鼠标悬停时放大 1.1 倍 */
    }

    img {
      width: 100%;
      height: 100%;
      object-fit: contain;

      :hover {
        transform: scale(1.1); /* 图片随容器一起放大 */
      }
    }
  }
}

.footer-copyright {
  width: 100%;
  text-align: center;
  padding-top: 16px;
  padding-bottom: 16px;
  border-top: 1px solid #f0f0f0;
  background: #F6F7F9;
  font-size: 12px;
  color: #999999;
  line-height: 1.8;
}

.mb-60 {
  margin-bottom: 60px;
}

.mb-40 {
  margin-bottom: 40px;
}

.mb-20 {
  margin-bottom: 20px;
}

@media (max-width: 1200px) {
  .main-content {
    flex-direction: column;
    padding: 30px 40px;
  }

  .promo-panel {
    max-width: 100%;
  }

  .login-panel {
    flex: 1;
    width: 100%;
    max-width: 500px;
  }
}

@media (max-width: 768px) {
  .header-title {
    font-size: 20px;
  }

  .promo-card {
    padding: 40px 30px;
  }

  .promo-title {
    font-size: 24px;
  }

  .login-card {
    padding: 36px 24px;
  }

  .footer {
    padding: 30px 20px 20px;
  }

  .footer-content {
    flex-direction: column;
  }
}
</style>

<template>
  <div class="login">
    <!-- 顶部标题 -->
    <div class="header">
      <div class="header-title">素养植根—高阶华文融媒体智能学习系统</div>
    </div>

    <!-- 主要内容区域 -->
    <div class="main-content">
      <!-- 左侧宣传面板 -->
      <div class="promo-panel">
        <div class="promo-card">
          <div class="promo-content">
            <div class="logo-circle">
              <div class="logo-circle-item">
                <div class="logo-text">素</div>
              </div>
              <div class="logo-circle-item">
                <div class="logo-text">养</div>
              </div>
              <div class="logo-circle-item">
                <div class="logo-text">植</div>
              </div>
              <div class="logo-circle-item">
                <div class="logo-text">根</div>
              </div>
            </div>
            <h1 class="promo-title">高阶华文融媒体智能学习系统</h1>
            <p class="promo-description">
              秉持专题学习思想,践行学习科学理论,契合高阶华文学习者真实需求,精心设计融情境、任务与活动驱动、自主探究为一体的三维融媒体智能学习空间,扎实提升语文核心素养。
            </p>
          </div>
        </div>
      </div>

      <!-- 右侧表单 -->
      <div class="login-panel">
        <div class="login-card">
          <!-- 登录表单 -->
          <template v-if="currentView === 'login'">
            <h2 class="login-title mb-60">登录</h2>
            <a-form-model
                class="login-form"
                :model="form"
                @submit="handleSubmit"
                @submit.native.prevent
                :rules="rules"
                ref="loginForm">
              <a-form-model-item prop="username">
                <a-input
                    class="login-input"
                    size="large"
                    v-model="form.username"
                    placeholder="请输入邮箱/手机号">
                </a-input>
              </a-form-model-item>
              <a-form-model-item prop="password">
                <a-input
                    class="login-input"
                    size="large"
                    v-model="form.password"
                    :type="passwordVisible ? 'text' : 'password'"
                    placeholder="请输入密码">
                  <a-icon
                      slot="suffix"
                      :type="passwordVisible ? 'eye' : 'eye-invisible'"
                      @click="passwordVisible = !passwordVisible"
                      style="color:rgba(0,0,0,.25); cursor: pointer;"/>
                </a-input>
              </a-form-model-item>
              <div class="login-links">
                <span class="register-link">
<!--                  还没有账号?<span class="link-text" @click="goToRegister">立即注册</span>-->
                </span>
                <span class="forgot-password" @click="handleForgotPassword">忘记密码</span>
              </div>
              <a-form-model-item>
                <a-button
                    class="login-button"
                    block
                    size="large"
                    type="primary"
                    html-type="submit"
                    :loading="loading"
                    :disabled="form.username === '' || form.password === ''">
                  登录
                </a-button>
              </a-form-model-item>
              <a-form-model-item class="agreement-checkbox">
                <a-checkbox v-model="agreed" placeholder="请勾选条款">
                  我已阅读并同意 <span class="link-text" @click="showAgreement">使用协议</span> 及 <span
                    class="link-text"
                    @click="showPrivacy">隐私政策</span>
                </a-checkbox>
              </a-form-model-item>
            </a-form-model>
          </template>

          <!-- 注册表单 -->
          <template v-if="currentView === 'register'">
            <h2 class="login-title mb-20">注册</h2>
            <a-form-model
                class="login-form"
                :model="registerForm"
                @submit="handleRegister"
                @submit.native.prevent
                :rules="registerRules"
                ref="registerForm">
              <div class="teacher-note">
                <a-icon type="check-circle" class="check-icon"/>
                <span class="teacher-text">教师</span>
                <span class="note-text">仅支持注册教师账户</span>
              </div>
              <a-form-model-item prop="username">
                <a-input
                    class="login-input"
                    size="large"
                    v-model="registerForm.username"
                    placeholder="请输入邮箱/手机号">
                </a-input>
              </a-form-model-item>
              <a-form-model-item prop="code">
                <div class="verification-code">
                  <a-input
                      class="login-input code-input"
                      size="large"
                      v-model="registerForm.code"
                      placeholder="请输入验证码">
                  </a-input>
                  <a-button
                      class="code-button"
                      size="large"
                      @click="getVerificationCode"
                      :disabled="codeCountdown > 0">
                    {{ codeCountdown > 0 ? `${codeCountdown}秒` : '获取验证码' }}
                  </a-button>
                </div>
              </a-form-model-item>
              <a-form-model-item prop="password">
                <a-input
                    class="login-input"
                    size="large"
                    v-model="registerForm.password"
                    :type="registerPasswordVisible ? 'text' : 'password'"
                    placeholder="请输入密码">
                  <a-icon
                      slot="suffix"
                      :type="registerPasswordVisible ? 'eye' : 'eye-invisible'"
                      @click="registerPasswordVisible = !registerPasswordVisible"
                      style="color:rgba(0,0,0,.25); cursor: pointer;"/>
                </a-input>
              </a-form-model-item>
              <a-form-model-item prop="confirmPassword">
                <a-input
                    class="login-input"
                    size="large"
                    v-model="registerForm.confirmPassword"
                    :type="confirmPasswordVisible ? 'text' : 'password'"
                    placeholder="请再次输入密码">
                  <a-icon
                      slot="suffix"
                      :type="confirmPasswordVisible ? 'eye' : 'eye-invisible'"
                      @click="confirmPasswordVisible = !confirmPasswordVisible"
                      style="color:rgba(0,0,0,.25); cursor: pointer;"/>
                </a-input>
              </a-form-model-item>
              <a-form-model-item>
                <a-button
                    class="login-button"
                    block
                    size="large"
                    type="primary"
                    html-type="submit"
                    :loading="loading"
                    :disabled="!canRegister">
                  注册
                </a-button>
              </a-form-model-item>
              <div class="login-link">
                已有账号?<span class="link-text" @click="goToLogin">去登录</span>
              </div>
            </a-form-model>
          </template>

          <!-- 忘记密码表单 -->
          <template v-if="currentView === 'forgot'">
            <h2 class="login-title mb-40">忘记密码</h2>
            <a-form-model
                class="login-form"
                :model="forgotForm"
                @submit="handleForgotPasswordSubmit"
                @submit.native.prevent
                :rules="forgotRules"
                ref="forgotForm">
              <a-form-model-item prop="username">
                <a-input
                    class="login-input"
                    size="large"
                    v-model="forgotForm.username"
                    placeholder="请输入邮箱/手机号">
                </a-input>
              </a-form-model-item>
              <a-form-model-item prop="code">
                <div class="verification-code">
                  <a-input
                      class="login-input code-input"
                      size="large"
                      v-model="forgotForm.code"
                      placeholder="请输入验证码">
                  </a-input>
                  <a-button
                      class="code-button"
                      size="large"
                      @click="getVerificationCode"
                      :disabled="codeCountdown > 0">
                    {{ codeCountdown > 0 ? `${codeCountdown}秒` : '获取验证码' }}
                  </a-button>
                </div>
              </a-form-model-item>
              <a-form-model-item prop="password">
                <a-input
                    class="login-input"
                    size="large"
                    v-model="forgotForm.password"
                    :type="forgotPasswordVisible ? 'text' : 'password'"
                    placeholder="请输入密码">
                  <a-icon
                      slot="suffix"
                      :type="forgotPasswordVisible ? 'eye' : 'eye-invisible'"
                      @click="forgotPasswordVisible = !forgotPasswordVisible"
                      style="color:rgba(0,0,0,.25); cursor: pointer;"/>
                </a-input>
              </a-form-model-item>
              <a-form-model-item prop="confirmPassword">
                <a-input
                    class="login-input"
                    size="large"
                    v-model="forgotForm.confirmPassword"
                    :type="forgotConfirmPasswordVisible ? 'text' : 'password'"
                    placeholder="请再次输入密码">
                  <a-icon
                      slot="suffix"
                      :type="forgotConfirmPasswordVisible ? 'eye' : 'eye-invisible'"
                      @click="forgotConfirmPasswordVisible = !forgotConfirmPasswordVisible"
                      style="color:rgba(0,0,0,.25); cursor: pointer;"/>
                </a-input>
              </a-form-model-item>
              <a-form-model-item>
                <a-button
                    class="login-button"
                    block
                    size="large"
                    type="primary"
                    html-type="submit"
                    :loading="loading"
                    :disabled="!canResetPassword">
                  重置密码
                </a-button>
              </a-form-model-item>
              <div class="login-link">
                已有账号?<span class="link-text" @click="goToLogin">去登录</span>
              </div>
            </a-form-model>
          </template>
        </div>
      </div>
    </div>

    <!-- 底部 Footer -->
    <div class="footer">
      <div class="footer-content">
        <div class="footer-left">
          <div class="footer-logo">
            <div class="footer-logo-icon">
              <svg aria-hidden="true">
                <use :xlink:href="footerLogoHref" />
              </svg>
            </div>
            <div class="footer-title">高阶华文融媒体智能学习系统
              <div class="footer-support">
                <div>学术支持: 北京师范大学语文素养工程研发团队</div>
                <div>技术支持: 北京汉雅天诚教育科技有限公司</div>
              </div>
            </div>
          </div>

        </div>
        <div class="footer-qrcodes">
          <div class="qrcode-item">
            <div class="qrcode-box">
              <img :src="require('@/assets/imgs/login/qrcode-support.png')" alt="客服支持"/>
            </div>
            <div class="qrcode-label">客服支持<br> 扫码添加企业微信</div>
          </div>
          <div class="qrcode-item">
            <div class="qrcode-box">
              <img :src="require('@/assets/imgs/login/qrcode-student.jpg')" alt="学生pad端下载"/>
            </div>
            <div class="qrcode-label">学生pad端下载</div>
          </div>
          <div class="qrcode-item">
            <div class="qrcode-box">
              <img :src="require('@/assets/imgs/login/qrcode-teacher.jpg')" alt="教师pad端下载"/>
            </div>
            <div class="qrcode-label">教师pad端下载</div>
          </div>
        </div>
      </div>
    </div>
    <div class="footer-copyright">
      <div>北京汉雅天诚教育科技有限公司版权所有 Copyright © Beijing Han-sky Education Technology Co., Ltd. All Rights
        Reserved.
      </div>
      <div>
        <img src="/imgs/logo_gongan.png" style="width: 16px; object-fit: contain;" />
        <a href="https://beian.mps.gov.cn/#/query/webSearch?code=11010802047990" rel="noreferrer" target="_blank"> 京公网安备11010802047990号 </a >
        <a href="https://beian.miit.gov.cn/#/Integrated/index" rel="noreferrer" target="_blank"> 京ICP备15041788号-15 </a >
      </div>
    </div>
  </div>
</template>

<script>
import shareState from 'utils/shareState.js'
import md5 from '../utils/md5.js'
import axios from 'axios'
import { CLIENT_ID, CLIENT_SECRET } from '../utils/authClient.js'
import loginLogoSvg from '@/assets/imgs/login/login-logo.svg'

const footerLogoHref = `#${(loginLogoSvg && loginLogoSvg.id) ? loginLogoSvg.id : loginLogoSvg}`

const rules = Object.freeze({
  username: [{ required: true, message: '请填写用户名' }],
  password: [{ required: true, message: '请填写密码' }]
})

export const getUserInfo = () => {
  const userStr = window.localStorage.getItem('user_info')
  let user = null
  try {
    user = JSON.parse(userStr)
  } catch (e) {
  }
  return user
}

export const clearUserInfo = () => {
  // window.localStorage.removeItem('user_info')
  window.localStorage.clear()
}

const setUserInfo = user => {
  let userStr = null
  try {
    userStr = JSON.stringify(user)
  } catch (e) {
  }
  userStr && window.localStorage.setItem('user_info', userStr)
}

export default {
  name: 'Login',
  data () {
    return {
      shareData: shareState.state,
      rules,
      currentView: 'login', // 'login', 'register', 'forgot'
      form: {
        username: '',
        password: ''
      },
      registerForm: {
        username: '',
        code: '',
        password: '',
        confirmPassword: ''
      },
      forgotForm: {
        username: '',
        code: '',
        password: '',
        confirmPassword: ''
      },
      registerRules: {},
      forgotRules: {},
      loading: false,
      passwordVisible: false,
      registerPasswordVisible: false,
      confirmPasswordVisible: false,
      forgotPasswordVisible: false,
      forgotConfirmPasswordVisible: false,
      agreed: false,
      codeCountdown: 0,
      footerLogoHref,
      md5,
      mrPhoto: require('../assets/imgs/teacher.png')
    }
  },
  created () {
    // 初始化验证规则
    this.registerRules = {
      username: [{ required: true, message: '请填写邮箱/手机号' }],
      code: [{ required: true, message: '请填写验证码' }],
      password: [{ required: true, message: '请填写密码' }],
      confirmPassword: [
        { required: true, message: '请再次输入密码' },
        { validator: this.validateConfirmPassword, trigger: 'blur' }
      ]
    }
    this.forgotRules = {
      username: [{ required: true, message: '' }],
      code: [{ required: true, message: '' }],
      password: [{ required: true, message: '' }],
      confirmPassword: [
        { required: true, message: '' },
        { validator: this.validateForgotConfirmPassword, trigger: 'blur' }
      ]
    }
    // 获取加密公钥
    this.getPublicSecret()
  },
  computed: {
    canRegister () {
      return this.registerForm.username &&
          this.registerForm.code &&
          this.registerForm.password &&
          this.registerForm.confirmPassword &&
          this.registerForm.password === this.registerForm.confirmPassword
    },
    canResetPassword () {
      return this.forgotForm.username &&
          this.forgotForm.code &&
          this.forgotForm.password &&
          this.forgotForm.confirmPassword &&
          this.forgotForm.password === this.forgotForm.confirmPassword
    }
  },
  methods: {
    handleSubmit (e) {
      if (!this.agreed) {
        this.$message.warning('请先阅读并同意使用协议及隐私政策')
        return
      }

      // 清除其他表单的验证状态，避免验证信息混乱
      this.$nextTick(() => {
        if (this.$refs.registerForm) {
          this.$refs.registerForm.clearValidate()
        }
        if (this.$refs.forgotForm) {
          this.$refs.forgotForm.clearValidate()
        }
      })

      const param = {
        client_id: CLIENT_ID,
        client_secret: CLIENT_SECRET,
        username: this.form.username.trim(),
        password: this.form.password,
        time: (new Date()).valueOf()
      }
      const sign = md5.paramMd5(param, 'client_secret', CLIENT_SECRET)
      param.sign = sign

      this.loading = true
      // 确保公钥存在
      this.getPublicSecret().then(() => {
        return this.$loginHttp.post('auth/res/v2/login', param)
      }).then(res => {
        this.loading = false
        // 检查响应是否有效
        if (!res || !res.data) {
          clearUserInfo()
          this.$message.error('登录失败，请稍后重试')
          return
        }

        if (res.data.resultCode === '0') {
          // 登录成功
          if (res.data.resultData && res.data.resultData.user) {
            if (res.data.resultData.user.photo && res.data.resultData.user.photo != null) {
              shareState.setUserPhoto(this.$userINfoBasePath + '/' + res.data.resultData.user.photo)
            } else {
              shareState.setUserPhoto(this.mrPhoto)
            }
            console.log('登录成功-解密后数据: ', res.data.resultData)
            setUserInfo(Object.assign(res.data.resultData.user, {
              user: [],
              class: [],
              access_token: res.data.resultData.tokenInfo.access_token
            }))
            this.$store.commit('setUser_Info', res.data.resultData.user)
            if (res.data.resultData.user.photo && res.data.resultData.user.photo != null) {
              this.$store.commit('setUserPhoto', this.$userINfoBasePath + '/' + res.data.resultData.user.photo)
            } else {
              this.$store.commit('setUserPhoto', '')
            }

            localStorage.setItem('access_token', res.data.resultData.tokenInfo.access_token)
            localStorage.setItem('userId', res.data.resultData.user.id)
            this.getClassNum()
            // 角色判断与页面跳转
            this.handleRoleAndRedirect(res.data.resultData)
          } else {
            clearUserInfo()
            this.$message.error('登录失败，响应数据异常')
          }
        } else {
          // 登录失败（密码错误等）
          clearUserInfo()
          this.$message.error(res.data.resultMessage || '登录失败')
        }
      }).catch(err => {
        this.loading = false
        console.error('登录请求异常:', err)
        clearUserInfo()
        if (err && err.message && err.message.includes('加密公钥不存在')) {
          this.$message.error('加密公钥获取失败，请刷新页面重试')
        } else if (err && err.response && err.response.data && err.response.data.resultMessage) {
          this.$message.error(err.response.data.resultMessage)
        } else if (err && err.message) {
          this.$message.error(err.message)
        } else {
          this.$message.error('登录失败，请稍后重试')
        }
      })
    },
    getClassNum () {
      this.$fetch({
        url: this.$baseUrl + 'ebook/class/common/getMyClassInfo',
        body: { userId: this.$getUserInfo().id }
      }).done(res => {
        if (res && res.success && res.resultCode == 0) {
          setUserInfo(Object.assign(getUserInfo(), {
            class: res.resultData || []
          }))
        }
      })
    },
    goToRegister () {
      this.currentView = 'register'
      this.registerForm = {
        username: '',
        code: '',
        password: '',
        confirmPassword: ''
      }
      // 清除所有表单验证状态
      this.$nextTick(() => {
        if (this.$refs.loginForm) {
          this.$refs.loginForm.clearValidate()
        }
        if (this.$refs.registerForm) {
          this.$refs.registerForm.clearValidate()
        }
        if (this.$refs.forgotForm) {
          this.$refs.forgotForm.clearValidate()
        }
      })
    },
    goToLogin () {
      this.currentView = 'login'
      this.form = {
        username: '',
        password: ''
      }
      this.agreed = false
      // 清除所有表单验证状态
      this.$nextTick(() => {
        if (this.$refs.loginForm) {
          this.$refs.loginForm.clearValidate()
        }
        if (this.$refs.registerForm) {
          this.$refs.registerForm.clearValidate()
        }
        if (this.$refs.forgotForm) {
          this.$refs.forgotForm.clearValidate()
        }
      })
    },
    handleForgotPassword () {
      this.currentView = 'forgot'
      this.forgotForm = {
        username: '',
        code: '',
        password: '',
        confirmPassword: ''
      }
      // 清除所有表单验证状态
      this.$nextTick(() => {
        if (this.$refs.loginForm) {
          this.$refs.loginForm.clearValidate()
        }
        if (this.$refs.registerForm) {
          this.$refs.registerForm.clearValidate()
        }
        if (this.$refs.forgotForm) {
          this.$refs.forgotForm.clearValidate()
        }
      })
    },
    validateConfirmPassword (rule, value, callback) {
      if (value && value !== this.registerForm.password) {
        callback(new Error('两次输入的密码不一致'))
      } else {
        callback()
      }
    },
    validateForgotConfirmPassword (rule, value, callback) {
      if (value && value !== this.forgotForm.password) {
        callback(new Error('两次输入的密码不一致'))
      } else {
        callback()
      }
    },
    getVerificationCode () {
      if (this.currentView === 'register') {
        if (!this.registerForm.username) {
          this.$message.warning('请先输入邮箱/手机号')
          return
        }
        // 判断是邮箱还是手机号
        const isEmail = /^([a-zA-Z0-9_-])+@([a-zA-Z0-9_-])+((\.[a-zA-Z0-9_-]{2,3}){1,2})$/.test(this.registerForm.username)
        if (isEmail) {
          this.getEmailVerificationCode(this.registerForm.username, '1')
        } else {
          this.getPhoneVerificationCode(this.registerForm.username, '1')
        }
      } else if (this.currentView === 'forgot') {
        if (!this.forgotForm.username) {
          this.$message.warning('请先输入邮箱/手机号')
          return
        }
        // 判断是邮箱还是手机号
        const isEmail = /^([a-zA-Z0-9_-])+@([a-zA-Z0-9_-])+((\.[a-zA-Z0-9_-]{2,3}){1,2})$/.test(this.forgotForm.username)
        if (isEmail) {
          this.getEmailVerificationCode(this.forgotForm.username, '3')
        } else {
          this.getPhoneVerificationCode(this.forgotForm.username, '3')
        }
      }
    },
    // 获取加密公钥
    getPublicSecret () {
      const encryptionKey = window.localStorage.getItem('encryptionKey')
      if (encryptionKey) {
        return Promise.resolve(encryptionKey)
      }
      return axios({
        url: this.$loginServer + 'auth/res/getPublicSecret'
      }).then((res) => {
        if (res && res.data && res.data.resultCode === '0' && res.data.resultData) {
          window.localStorage.setItem('encryptionKey', res.data.resultData)
          return res.data.resultData
        } else {
          throw new Error('获取公钥失败')
        }
      }).catch((err) => {
        console.error('获取加密公钥失败:', err)
        throw err
      })
    },
    // 获取邮箱验证码
    getEmailVerificationCode (email, sendType) {
      const hide = this.$message.loading('验证码发送中..', 0)

      const param = {
        client_id: CLIENT_ID,
        client_secret: CLIENT_SECRET,
        email: email.trim(),
        sendType: sendType,
        time: (new Date()).valueOf()
      }
      const sign = md5.paramMd5(param, 'client_secret', CLIENT_SECRET)
      param.sign = sign

      this.$loginHttp.post('auth/res/encrypt/sendEmailVerCode', param).then(res => {
        if (res && res.data && res.data.resultData && res.data.resultCode === '0') {
          this.codeCountdown = 180
          const interval = window.setInterval(() => {
            this.codeCountdown--
            if (this.codeCountdown <= 0) {
              this.codeCountdown = 0
              window.clearInterval(interval)
            }
          }, 1000)
          setTimeout(hide, 500)
          this.$message.success('验证码获取成功,请您到注册的邮箱查看')
        } else {
          setTimeout(hide, 500)
          this.$message.error(res.data.resultMessage || '验证码发送失败')
        }
      }).catch(err => {
        setTimeout(hide, 1)
        this.$message.error('验证码发送失败，请稍后重试')
      })
    },
    // 获取手机验证码
    getPhoneVerificationCode (phone, sendType) {
      const hide = this.$message.loading('验证码发送中..', 0)

      const param = {
        client_id: CLIENT_ID,
        client_secret: CLIENT_SECRET,
        phone: phone.trim(),
        sendType: sendType,
        time: (new Date()).valueOf()
      }
      const sign = md5.paramMd5(param, 'client_secret', CLIENT_SECRET)
      param.sign = sign

      this.$loginHttp.post('auth/res/encrypt/sendPhoneVerCode', param).then(res => {
        if (res && res.data && res.data.resultData && res.data.resultCode === '0') {
          this.codeCountdown = 180
          const interval = window.setInterval(() => {
            this.codeCountdown--
            if (this.codeCountdown <= 0) {
              this.codeCountdown = 0
              window.clearInterval(interval)
            }
          }, 1000)
          setTimeout(hide, 500)
          this.$message.success('验证码获取成功,请您手机查看')
        } else {
          setTimeout(hide, 500)
          this.$message.error(res.data.resultMessage || '验证码发送失败')
        }
      }).catch(err => {
        setTimeout(hide, 1)
        this.$message.error('验证码发送失败，请稍后重试')
      })
    },
    handleRegister () {
      this.$refs.registerForm.validate(valid => {
        if (!valid) {
          return false
        }

        if (!this.registerForm.username || !this.registerForm.code ||
            !this.registerForm.password || !this.registerForm.confirmPassword) {
          this.$message.warning('请填写完整信息')
          return
        }

        if (this.registerForm.password !== this.registerForm.confirmPassword) {
          this.$message.error('两次输入的密码不一致')
          return
        }

        // 判断是邮箱还是手机号
        const isEmail = /^([a-zA-Z0-9_-])+@([a-zA-Z0-9_-])+((\.[a-zA-Z0-9_-]{2,3}){1,2})$/.test(this.registerForm.username)

        const hide = this.$message.loading('注册中..', 0)
        const param = {
          client_id: CLIENT_ID,
          client_secret: CLIENT_SECRET,
          code: this.registerForm.code,
          password: this.registerForm.password,
          confirmPassword: this.registerForm.confirmPassword,
          time: (new Date()).valueOf(),
          params: {
            successStrategyType: 0,
            roleType: 2 // 教师角色
          }
        }

        if (isEmail) {
          param.email = this.registerForm.username.trim()
        } else {
          param.phone = this.registerForm.username.trim()
        }

        const sign = md5.paramMd5(param, 'client_secret', CLIENT_SECRET)
        param.sign = sign

        const url = isEmail ? 'auth/res/v2/emailCodeRegister' : 'auth/res/v2/phoneCodeRegister'
        this.$loginHttp.post(url, param).then(res => {
          if (res && res.data && res.data.resultCode === '0') {
            setTimeout(hide, 500)
            this.$message.success('注册成功')
            // 注册成功后跳转到登录页面
            setTimeout(() => {
              this.goToLogin()
              this.form.username = this.registerForm.username
            }, 1000)
          } else {
            setTimeout(hide, 500)
            this.$message.error(res.data.resultMessage || '注册失败')
          }
        }).catch(err => {
          setTimeout(hide, 500)
          this.$message.error('注册失败，请稍后重试')
        })
      })
    },
    handleForgotPasswordSubmit () {
      this.$refs.forgotForm.validate(valid => {
        if (!valid) {
          return false
        }

        if (!this.forgotForm.username || !this.forgotForm.code ||
            !this.forgotForm.password || !this.forgotForm.confirmPassword) {
          this.$message.warning('请填写完整信息')
          return
        }

        if (this.forgotForm.password !== this.forgotForm.confirmPassword) {
          this.$message.error('两次输入的密码不一致')
          return
        }

        // 判断是邮箱还是手机号
        const isEmail = /^([a-zA-Z0-9_-])+@([a-zA-Z0-9_-])+((\.[a-zA-Z0-9_-]{2,3}){1,2})$/.test(this.forgotForm.username)

        const hide = this.$message.loading('修改密码中..', 0)
        const param = {
          client_id: CLIENT_ID,
          client_secret: CLIENT_SECRET,
          code: this.forgotForm.code,
          password: this.forgotForm.password,
          confirmPassword: this.forgotForm.confirmPassword,
          time: (new Date()).valueOf()
        }

        if (isEmail) {
          param.email = this.forgotForm.username.trim()
        } else {
          param.phone = this.forgotForm.username.trim()
        }

        const sign = md5.paramMd5(param, 'client_secret', CLIENT_SECRET)
        param.sign = sign

        const url = isEmail ? 'auth/res/encrypt/forgetByEmailCodeResetUserPwd' : 'auth/res/encrypt/forgetByPhoneCodeResetUserPwd'
        this.$loginHttp.post(url, param).then(res => {
          if (res && res.data && res.data.resultCode === '0') {
            setTimeout(hide, 500)
            this.$message.success('修改密码成功')
            // 修改成功后跳转到登录页面
            setTimeout(() => {
              this.goToLogin()
              this.form.username = this.forgotForm.username
            }, 1000)
          } else {
            setTimeout(hide, 500)
            this.$message.error(res.data.resultMessage || '修改密码失败')
          }
        }).catch(err => {
          setTimeout(hide, 500)
          this.$message.error('修改密码失败，请稍后重试')
        })
      })
    },
    handleRoleAndRedirect (decryptedData) {
      this.$message.success('登录成功，正在跳转...')
      setTimeout(() => {
        // 检查角色列表，无角色信息，跳转学生端
        if (!decryptedData.user.roleList || decryptedData.user.roleList.length === 0) {
          // this.$message.warning('角色信息为空，跳转到默认页面')
          // this.$router.push('/')
          const baseUrl = this.$studentUrl.replace(/\/$/, '')
          if (process.env.NODE_ENV === 'production') {
            window.location.href = baseUrl + '/stu/#/books'
          } else {
            window.location.href = baseUrl + '/stu1/#/books'
          }
          return
        }

        // 查找教师角色
        const roleFlag = decryptedData.user.roleList.find(item => item.roleName === 'ROLE_TEACHER_ENT')

        // 根据角色跳转，参考登录页面的跳转逻辑
        if (this.$studentUrl) {
          const baseUrl = this.$studentUrl.replace(/\/$/, '')
          if (process.env.NODE_ENV === 'production') {
            window.location.href = roleFlag ? baseUrl + '/tea/#/homePage' : baseUrl + '/stu/#/books'
          } else {
            window.location.href = roleFlag ? baseUrl + '/tea1/#/homePage' : baseUrl + '/stu1/#/books'
              // window.location.href = roleFlag ? 'http://192.168.6.157:8888/#/homePage' : baseUrl + '/stu1/#/books'
          }
        } else {
          // 如果没有配置 $studentUrl，使用路由跳转
          this.$router.push('/')
        }
      }, 1000)
    },
    showAgreement () {
      // 显示用户协议
      window.open('https://fjnu.gaojiehuawen.com/privacy/fjnurjxk.html', '_blank')
    },
    showPrivacy () {
      // 显示隐私政策
      window.open('https://fjnu.gaojiehuawen.com/privacy/fjnuyszc.html', '_blank')
    },
    getUserInfo,
    setUserInfo
  }
}
</script>
